import AboutUsVisionBlueLeft from '@assets/images/aboutUsVisionBlueLeft.png';
import AboutUsVisionOrangeRight from '@assets/images/aboutUsVisionOrangeRight.png';
import AboutUsVisionBlueLeftMobile from '@assets/images/aboutUsVisionBlueLeftMobile.png';
import AboutUsVisionOrangeRightMobile from '@assets/images/aboutUsVisionOrangeRightMobile.png';
import Image from 'next/image';
import styles from './styles.module.scss';

const OurVision = () => (
  <div className={styles.ourVisionWrapper}>
    {/* Background Image */}
    <Image className={styles.aboutUsVisionBlueLeft} alt="" src={AboutUsVisionBlueLeft} />
    <Image className={styles.aboutUsVisionOrangeRight} alt="" src={AboutUsVisionOrangeRight} />
    <Image
      className={styles.aboutUsVisionBlueLeftMobile}
      alt=""
      src={AboutUsVisionBlueLeftMobile}
    />
    <Image
      className={styles.aboutUsVisionOrangeRightMobile}
      alt=""
      src={AboutUsVisionOrangeRightMobile}
    />

    <div className={styles.ourVisionContainer}>
      {/* Content */}
      <div className={styles.ourVisionTitle}>
        <div className={styles.ourVisionTitleLinearGradient}>Our Vision.</div>
        <div>
          {'To create a highly engaging and impactful Employee & \nRewards Benefits application.'}
        </div>
      </div>
      <div className={styles.ourVisionContent}>
        <p>
          Fosters a culture of recognition and rewards, empowers employees to thrive, and drives
          overall employee engagement.
        </p>
        <p>
          We aim to revolutionise the way organisations appreciate and motivate their employees,
          ultimately enhancing employee satisfaction, productivity, and loyalty.
        </p>
      </div>
    </div>
  </div>
);

export default OurVision;
